export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <div className="video-responsive mt-5">
              <video
                className="video1"
                controls
                playsInline
                preload="metadata"
                poster="/videos/crewcoin-intro-poster.jpg"
                muted={false}
                onLoadedMetadata={(e) => {
                  e.currentTarget.muted = false;
                  e.currentTarget.defaultMuted = false;
                  e.currentTarget.volume = 1;
                }}
              >
                <source src="/videos/crewcoin-intro.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>What it does</h2>
              <p>{props.data ? props.data.paragraph : "loading..."}</p>
              <h3>Why managers use it</h3>
              <div className="list-style">
                <div className="col-lg-6 col-xs-6 col-xs-12">
                  <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                        <li key={`${d}-${i}`}> {d}</li>
                      ))
                      : "loading"}
                  </ul>
                </div>
                <div className="col-lg-6 col-xs-6 col-xs-12">
                  <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                        <li key={`${d}-${i}`}> {d}</li>
                      ))
                      : "loading"}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};